import styled from 'styled-components'

export const AppHeader = styled.div`
  width: 100%
  border-top: 4px solid ${props => props.theme.colors.yellow};
  margin: 0 0 1rem 0;
`
